
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import ChatTextarea from './ChatTextarea.vue'
import ChatInputAudioComponent from './ChatInputAudioComponent.vue'
import ChatChallengesComponent from './ChatChallengesComponent.vue'
import ChatAttachmentUploadComponent from './ChatAttachmentUploadComponent.vue'
import ChatInputMenu from './ChatInputMenu.vue'
import ChatSwitcher from './ChatSwitcher.vue'

import { ChatAttachment } from '../../lib/chat/ChatAttachment'
import { ChatService } from '@/lib/chat/ChatService'
import { ChatMessage } from '@/lib/chat/ChatMessage'
import { DeviceUtils } from '@/lib/utils/DeviceUtils'
import { FileUtils } from '@/lib/utils/FileUtils'
import UIkit from 'uikit'

import ChatPrefixedInput from './ChatPrefixedInput.vue'

import 'emoji-picker-element'

import { Game } from '../../lib/models/Game'

@Component({
  components: {
    ChatTextarea,
    ChatInputAudioComponent,
    ChatChallengesComponent,
    ChatPrefixedInput,
    ChatAttachmentUploadComponent,
    ChatInputMenu,
    ChatSwitcher
  }
})
export default class ChatInputComponent extends Vue {
  @Prop({ default: null }) chatService!: ChatService | null;

  pickedMenuOption = '';

  showEmojiPicker = false;
  emojiPickerLeft = '100px';

  isMobile = true;

  showChallengeSelector = false;
  selectedChallenge: Game | null = null;
  important = false;
  own = false;

  get content () {
    return this.$store.state.Chat.sendMessage.content
  }

  get user () {
    return this.$store.state.LoggedInUser.user
  }

  @Watch('content')
  onContentChange () {
    this.$store.state.Chat.sendMessage.content = this.content
  }

  inputKeyDown (ev: KeyboardEvent) {
    if (ev.key === 'Enter' && (!this.content || !this.content.trim())) {
      ev.preventDefault()
      this.$store.state.Chat.sendMessage.content = ''
      return
    }
    if (ev.key === 'Enter' && !ev.shiftKey) {
      ev.preventDefault()
      this.sendMessage()
    }
  }

  mounted () {
    this.isMobile = DeviceUtils.isMobile()
    if (!this.isMobile) {
      this.calculateEmojiPickerPosition()
    }
    window.addEventListener('resize', this.calculateEmojiPickerPosition)
    window.addEventListener('click', this.checkOutsideClickClose)

    setInterval(() => {
      if (this.$refs.borderRightElement) {
        (this.$refs.borderRightElement as HTMLElement).style.right =
          Math.random() / 100 + 'px'
      }
    }, 100)
  }

  checkOutsideClickClose (ev: MouseEvent) {
    const emojiPicker = document.querySelector('emoji-picker')
    const emojiIcon = this.$refs.emojiIcon as HTMLElement
    if (!emojiPicker) {
      return
    }

    if (
      emojiPicker !== ev.target &&
      !emojiPicker.contains(ev.target as HTMLElement) &&
      emojiIcon !== ev.target &&
      !emojiIcon.contains(ev.target as HTMLElement)
    ) {
      this.showEmojiPicker = false
    }
  }

  @Watch('showEmojiPicker')
  calculateEmojiPickerPosition () {
    const emojiIcon = this.$refs.emojiIcon as HTMLElement
    if (!emojiIcon) {
      return
    }
    if (window.innerWidth > 500) {
      this.emojiPickerLeft =
        emojiIcon.getBoundingClientRect().left - 344 + 'px'
    } else {
      // for small devices
      this.emojiPickerLeft =
        emojiIcon.getBoundingClientRect().left - 230 + 'px'
    }
    if (this.showEmojiPicker) {
      setTimeout(() => {
        const emojiPicker = document.querySelector('emoji-picker')
        if (emojiPicker) {
          emojiPicker.addEventListener('emoji-click', (event) => {
            if (event.detail && event.detail.unicode) {
              if (!this.$store.state.Chat.sendMessage.content) {
                this.$store.state.Chat.sendMessage.content = ''
              }

              this.$store.state.Chat.sendMessage.content +=
                event.detail.unicode
            }
          })
        }
      })
    }
  }

  async sendMessage () {
    if (!this.$store.state.Chat.uploadFiles.length && this.$store.state.Chat.uploadType === 'challenge') {
      UIkit.notification({
        message: 'Bitte füge mit Klick auf die Büroklammer ein Foto oder Video hinzu um eine Nachricht abzuschicken!',
        status: 'success',
        timeout: 3000,
        pos: 'top-center'
      })
      return
    }

    await Promise.all(
      this.$store.state.Chat.uploadFiles.map(async (file: File) => {
        // COMMENTED OUT = CHUNK UPLOADING
        // const fileContent = await FileUtils.toBase64(file)

        const chatAttachment = new ChatAttachment()
        chatAttachment.type = ChatAttachment.ATTACHMENT_TYPE_IMG // TODO: detect different attachment types

        if (file.type.startsWith('video')) {
          chatAttachment.type = ChatAttachment.ATTACHMENT_TYPE_VIDEO
        }

        if (ChatAttachment.isFileDocument(file)) {
          chatAttachment.type = ChatAttachment.ATTACHMENT_TYPE_DOCUMENT
        }

        /* if (typeof fileContent === 'string') {
        chatAttachment.source = fileContent
      } */
        chatAttachment.rawFile = file
        chatAttachment.rawFileName = file.name

        this.$store.state.Chat.sendMessage.attachments.push(chatAttachment)
      })
    )
    this.showEmojiPicker = false
    this.$store.state.Chat.sendMessage.user =
      this.$store.state.LoggedInUser.user
    if (this.selectedChallenge) {
      this.$store.state.Chat.sendMessage.gameId = this.selectedChallenge.id
    }

    if (this.important) {
      this.$store.state.Chat.sendMessage.important = this.important
    }

    if (this.chatService) {
      this.chatService.addMessageToQueue(this.$store.state.Chat.sendMessage)
    } else {
      this.$emit('tryCreateChatService')
    }
    this.$store.state.Chat.sendMessage = new ChatMessage()
    this.$emit('sentMessage')

    this.$store.state.Chat.uploadFiles = []

    this.selectedChallenge = null

    this.$store.commit('setUploadType', '')
  }

  onAttachmentButtonClick () {
    if (this.$store.state.Chat.driveUploaderSelected) {
      return // if upload selected, ignore attachment button click
    }
    (this.$refs.attachmentFileDialog as HTMLInputElement).click()
  }

  onAttachmentChange (event: InputEvent) {
    const attachmentFileDialog = this.$refs
      .attachmentFileDialog as HTMLInputElement
    const fileArray: File[] = []
    if (!attachmentFileDialog.files) {
      return
    }
    for (let i = 0; i < attachmentFileDialog.files.length; i++) {
      fileArray.push(attachmentFileDialog.files[i])
    }
    this.$store.commit('updateUploadFiles', fileArray)
  }

  @Watch('selectedChallenge')
  onSelectedChallenge () {
    this.$emit('selectedChallenge', this.selectedChallenge)
  }

  @Watch('important')
  onImportantChange () {
    this.$emit('importantSelected', this.important)
  }

  @Watch('own')
  onOwnChange () {
    this.$emit('ownSelected', this.own)
  }
}
